import { render, staticRenderFns } from "./new-partner-form.vue?vue&type=template&id=0334a6c4&"
import script from "./new-partner-form.vue?vue&type=script&lang=js&"
export * from "./new-partner-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports